import { stringify } from "qs";
import { Pagination } from "element-ui";
import { mapState } from "vuex";

export default {
  data() {
    return {
      query: this.$route.query,
      params: this.$route.params,
      //分页——start
      pageNum: 1,
      pageSize: 6,
      total: 0,
      //分页——end
      info: {},
      list: []
    };
  },
  components: {
    "el-pagination": Pagination
  },
  computed: mapState({
    menu: state => state.main.menu
  }),
  async mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
    if (typeof this.init === "function") this.init();
  },
  methods: {
    getMenuList({
      pageNum = this.pageNum,
      pageSize = this.pageSize,
      menuId = this.params.menuId
    } = {}) {
      return new Promise(resolve => {
        this.$api.cms.web.siteContent_listForClient
          .get({
            pageNum,
            pageSize,
            menuId
          })
          .then(res => {
            this.total = Number(res.data.total);
            resolve(res.data.pageList);
          });
      });
    },
    getMenuInfo(id) {
      return new Promise(resolve => {
        this.$api.cms.web.siteMenu_details
          .get({
            id
          })
          .then(res => {
            resolve(res.data);
          });
      });
    },
    async toMenu(pageType, id) {
      let data = [];
      switch (pageType) {
        case "模板1-新闻列表":
          this.$router.push({
            path: "/word_list1/" + id
          });
          break;
        case "首页模板-自考-06-新闻中心":
          this.$router.push({
            path: "/word_list1/" + id
          });
          break;
        case "首页模板-公司-03-集团新闻":
          this.$router.push({
            path: "/word_list1/" + id
          });
          break;
        case "模板2-图片列表（含文字）":
          this.$router.push({
            path: "/word_list2",
            query: {
              id
            }
          });
          break;
        case "模板3-图片展示分页可点击":
          this.$router.push({
            path: "/word_list3/" + id
          });
          break;
        case "模板4-图片拼贴展示":
          this.$router.push({
            path: "/word_list4",
            query: {
              id
            }
          });
          break;
        case "模板5-纯图片展示":
          this.$router.push({
            path: "/word_list5",
            query: {
              id
            }
          });
          break;
        case "模板6-图文列表内容":
          this.$router.push({
            path: "/word_list6",
            query: {
              id
            }
          });
          break;
        case "模板7-时间轴":
          this.$router.push({
            path: "/word_list7/" + id
          });
          break;
        case "模板8-内容展示":
          this.$router.push({
            path: "/word_list8",
            query: {
              id
            }
          });
          break;
        case "模板9-联系我们":
          this.$router.push({
            path: "/concact_us",
            query: {
              id
            }
          });
          break;
        case "模板11-招聘岗位":
          this.$router.push({
            path: "/word_list11",
            query: {
              id
            }
          });
          break;
        case "模板12-全国布局":
          this.$router.push({
            path: "/word_list12",
            query: {
              id
            }
          });
          break;
        case "模板13-图文封面列表":
          this.$router.push({
            path: "/word_list13/" + id
          });
          break;
        case "模板14-纯图片展示分页":
          this.$router.push({
            path: "/word_list14/" + id
          });
          break;
        case "模板15-全屏大图展示":
          this.$router.push({
            path: "/word_list15",
            query: {
              id
            }
          });
          break;
        case "模板16-1行4列介绍列表":
          this.$router.push({
            path: "/word_list16/" + id
          });
          break;
        case "模板17-单个新标签打开链接":
          data = await this.getMenuList({
            pageNum: 1,
            pageSize: 1,
            menuId: id
          });
          window.open(data[0].url);
          break;
        case "模板20-标题视频列表":
          this.$router.push({
            path: "/word_list20/" + id
          });
          break;
      }
    },
    toUrl(url) {
      if (!url) return;
      const domain = document.domain;
      console.log(domain);
      if (url.indexOf(domain) > -1) {
        window.open(url, "_self");
      } else {
        window.open(url);
      }
    },
    getMenu2(title) {
      for (let item of this.menu.list) {
        if (item.name === title) {
          return item;
        }
      }
    },
    getMenuSubList(title) {
      const menu = this.getMenu2(title);
      if (menu) {
        return menu.subMenus;
      }
    },
    getMenuList2({
      pageNum = this.pageNum,
      pageSize = this.pageSize,
      menuId = this.params.menuId
    } = {}) {
      return new Promise(resolve => {
        this.$api.cms.web.siteContent_listForClientOrderByPublishTime
          .get({
            pageNum,
            pageSize,
            menuId
          })
          .then(res => {
            this.total = Number(res.data.total);
            resolve(res.data.pageList);
          });
      });
    },
    async getInfo() {
      return new Promise(async resolve => {
        let contList = [];
        let info = {};

        if (this.query.pType === "one") {
          contList = await this.getMenuList();
          if (contList && contList.length) {
            info = await this.getAjaxInfo(contList[0].id);
          }
        } else {
          info = await this.getAjaxInfo(this.params.menuId);
        }

        this.info = info;
        resolve(info);
      });
    },
    getAjaxInfo(id) {
      return new Promise(resolve => {
        this.$api.cms.web.siteContent_detailsForClient
          .get({
            id
          })
          .then(res => {
            resolve(res.data);
          });
      });
    },
    async getList() {
      this.list = await this.getMenuList();
      localStorage.setItem("dataList", JSON.stringify(this.list));
    },
    async getList2() {
      this.list = await this.getMenuList2();
      localStorage.setItem("dataList", JSON.stringify(this.list));
    },
    async getListAndInfo() {
      let list = await this.getMenuList();
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        const info = await this.getAjaxInfo(item.id);
        if (info) {
          list[i] = {
            ...item,
            ...info
          };
        }
      }
      this.list = list;
    },
    onCurrentChange(val) {
      this.pageNum = val;
      if (typeof this.getAjax === "function") {
        this.getAjax();
      }
    },
    getMenu(title) {
      for (let item of this.menu.list) {
        for (let item2 of item.subMenus) {
          if (item2.name === title) {
            return item2;
          }
        }
      }
    },
    getMenuPath(title) {
      const menu = this.getMenu(title);
      if (menu) {
        return menu.path;
      }
    },
    getMenuId(title) {
      const menu = this.getMenu(title);
      if (menu) {
        return menu.id;
      }
    },
    // 获取配置项
    async getMenuConfig(title, key) {
      const menu = this.getMenu(title);
      if (menu) {
        const ids = await this.getMenuList({
          menuId: menu.id
        });
        if (ids.length) {
          const res = await this.getAjaxInfo(ids[0].id);
          if (key) {
            return res[key];
          } else {
            return res;
          }
        }
      }
    },
    stringify,
    handleScroll() {
      const { scrollY, innerHeight } = window;
      const elList = document.querySelectorAll(".kf-animate");
      const maxTop = scrollY + innerHeight * 0.9;
      for (const el of elList) {
        if (
          maxTop > el.offsetTop + el.clientHeight / 2 &&
          el.offsetTop + el.clientHeight / 2 > scrollY
        ) {
          el.classList.add("animate-on");
        }
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.init();
  }
};
